//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    row:[Object]
  },
  data: function () {
    return {
      submiting: false,
      // submiting: true,
      currentRow: {},
      state: {
        submiting: false,
        showPopover: false,
        showPopover1: false,
        showPopover2: false,
        showPopover3: false
      }
    }
  },
  computed: {
    rowData(){
      return {data:this.currentRow, submiting:this.submiting}
    }
  },
  watch: {
    row: {
      handler (val) {
        if (val) {
          this.currentRow = _.deepClone(this.row)
        }
      },
      deep:true,
      immediate: true
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {

  }
}
